// extracted by mini-css-extract-plugin
export default {"galleryCards":"ImageCard_galleryCards__IKkXt","productImage":"ImageCard_productImage__I3LOc"};